export enum EBreakpoint {
  XS = 0,
  XM = 420,
  SM = 576,
  MD = 768,
  LG = 1024,
  XL = 1200,
  XXL = 1400,
}
